<template>
    <v-card  height="100%">
        <DlgMessage ref="dlgMsg" @dlgClose="dlgClose"></DlgMessage>
        <DlgEdcReceiptTemplateAdd ref="dlgCommon" :visible="visible" @close="dlgClose"></DlgEdcReceiptTemplateAdd>
        <div class="pa-3">
            <v-toolbar>
            <v-toolbar-title>Receipt Template</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-breadcrumbs :items="items"></v-breadcrumbs>
            </v-toolbar>
        </div>
        <div class="pa-3">
        <v-card>
        <v-card-title>
        <v-spacer></v-spacer>
        <v-btn icon dark class="primary mr-2" @click="refreshDataTable"><v-icon>mdi-refresh</v-icon></v-btn>         
        <v-btn icon dark class="mb-2 success" @click="addRecord">
            <v-icon>mdi-plus</v-icon>
        </v-btn>
        </v-card-title>
        <v-card-text>

        <v-text-field
            v-model="tblSearch"
            append-icon="mdi-magnify"
            label="Search data below"
            hide-details
            outlined
        ></v-text-field>
        </v-card-text>

        <v-data-table
        v-model="selected"  
        ref="vuetable"
        item-key="'tblIndex' + edc_rcpt_template_id"
        :headers="tblHeaders"
        :items="tblBody"
        :search="tblSearch"
        :loading = "loadingFlag"
        loading-text="Loading... Please wait"    
        @click:row="openDetail"
        ></v-data-table>
        </v-card>
        </div>

    </v-card>

</template>
<script>
//import axios from 'axios';
import DlgMessage from '@/components/DlgMessage'
import ApEdcRcptService from "@/services/ApEdcRcptService"
import DlgEdcReceiptTemplateAdd from "@/components/merchants/DlgEdcReceiptTemplateAdd";
export default {
    components:{DlgMessage,DlgEdcReceiptTemplateAdd},
    data() {
        return{
            //breadcrumb
            items: [
              {text:'Merchant',disabled: false,href:'/merchants',},
              {text:'Receipt Template',disabled: false,href:'/merchants/edcrt',},
              {text:'List',disabled: false,href:'#',},
              ],
            selected: [],
            tblHeaders:[
                { text:"Code", value:"rt_code" },
                { text:"Name", value:"rt_name" },
                { text:"Type", value:"receipt_type_description" },
                { text:"Status", value:"status" },
            ],
            tblBody:[],
            tblSearch:'',
            loadingFlag : false,
            errorFlag : false,
            visible:false,
            form:{
                merchant_id:0,
                login_id:'',
            },

        }
    },
    async created() {
      this.refreshDataTable();
    },
    methods:{
            async refreshDataTable(){
                this.loadingFlag = true
                try{
                    ApEdcRcptService.list_edc_rcpt_template(this.form).then((res) => {
                        //console.log(res);
                        this.tblBody = res.data.data;
                        this.loadingFlag = false;
                        this.errorFlag = false;
                    }).catch((e)=>{
                        //console.log(e.response);
                        this.$refs.dlgMsg.showDlgBox(true,'error','EDC Receipt Template',e.response.data.error_message);
                        this.loadingFlag = false
                        this.errorFlag = true;
                    })
                    ;
                } catch(e) {
                    this.loadingFlag = false
                    this.$refs.dlgMsg.showDlgBox(true,'error','EDC Receipt Template','Unknown Error');
                  
                }           
            },
			openDetail(obj){
				//console.log(obj.edc_rcpt_template_id)
				this.$router.push({ name: 'edcrt-details', 
					params: { 
						edc_rcpt_template_id: obj.edc_rcpt_template_id,
					} 
				})

			},

            addRecord(){
                this.visible = true;
            },
            dlgClose(){
                this.visible = false;
                if(!this.errorFlag)
                    this.refreshDataTable();
            },

    }

}
</script>